import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const familyFeatures = [
  {
    icon: '📍',
    title: "Position partagée selon les protections",
    description: "MonAlerteEnfant transmet la position, l’adresse ou le lieu utile aux parents autorisés lorsque le partage correspondant est activé."
  },
  {
    icon: '🏰',
    title: "Zones de sécurité",
    description: "Le parent les configure dans MonAlerte ; MonAlerteEnfant les applique sur le téléphone de l’enfant et peut signaler les événements prévus."
  },
  {
    icon: '🚸',
    title: "Itinéraires accompagnés",
    description: "Les itinéraires et protections sont préparés par le parent dans MonAlerte et affichés à l’enfant dans MonAlerteEnfant."
  },
  {
    icon: '🚨',
    title: "Alerte d’urgence",
    description: "L’enfant peut déclencher une alerte depuis MonAlerteEnfant avec les protections et autorisations effectivement actives sur son téléphone."
  },
  {
    icon: '🗣️',
    title: "Lien avec la famille",
    description: "MonAlerteEnfant permet les échanges avec les parents associés à la famille, dans le cadre configuré par le responsable légal."
  }
];

const ChildProtection = () => {
  return (
    <section 
      id="child-protection" 
      className="section-padding"
      style={{
        background: 'linear-gradient(180deg, #050b14 0%, #081222 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div 
        className="bg-glow-sphere" 
        style={{ 
          width: '35vw', 
          height: '35vw', 
          background: 'rgba(242, 184, 7, 0.03)', 
          top: '20%', 
          right: '-10%' 
        }} 
      />

      <div style={{ maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '50px',
          alignItems: 'center'
        }}>
          
          {/* Left Column - Presentation text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
          >
            <span className="badge-gold">👨‍👩‍👧‍👦 MonAlerte Famille</span>
            <h2 style={{
              fontSize: 'clamp(2rem, 4.5vw, 2.8rem)',
              color: 'var(--mga-white)',
              marginTop: '10px',
              marginBottom: '20px',
              lineHeight: '1.2'
            }}>
              Une famille, deux applications. <br />
              <span style={{ color: 'var(--mga-gold)' }}>MonAlerte et MonAlerteEnfant.</span>
            </h2>
            <p style={{ fontSize: '1.05rem', marginBottom: '20px', color: 'var(--mga-slate-300)' }}>
              <strong>MonAlerte</strong> est l’application du parent ou responsable légal : elle permet de créer la famille, d’associer l’enfant et de configurer les protections.
            </p>
            <p style={{ fontSize: '1.05rem', marginBottom: '25px', color: 'var(--mga-slate-300)' }}>
              <strong>MonAlerteEnfant</strong> est l’application installée sur le téléphone de l’enfant. Elle lui montre ce qui est réellement actif, permet l’alerte et applique les réglages familiaux avec les autorisations Android nécessaires.
            </p>
            <Link
              to="/politique-confidentialite-enfant"
              className="button-secondary"
              style={{ display: 'inline-flex', padding: '10px 18px', fontSize: '0.9rem' }}
            >
              Découvrir la politique MonAlerteEnfant
            </Link>
          </motion.div>

          {/* Right Column - Features list */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
            className="glass-card"
            style={{
              padding: '35px 30px',
              background: 'rgba(11, 31, 58, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.05)',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px'
            }}
          >
            {familyFeatures.map((feat, i) => (
              <div key={i} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div style={{
                  width: '42px',
                  height: '42px',
                  borderRadius: '10px',
                  backgroundColor: 'rgba(242, 184, 7, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.3rem',
                  flexShrink: 0
                }}>
                  {feat.icon}
                </div>
                <div>
                  <h4 style={{ color: 'var(--mga-white)', fontSize: '1.05rem', marginBottom: '4px' }}>
                    {feat.title}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--mga-slate-400)', lineHeight: '1.5' }}>
                    {feat.description}
                  </p>
                </div>
              </div>
            ))}
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default ChildProtection;
